import { Frame } from 'common/components';

import { ModalAction } from 'common/redux/modal/initialState';

import { memoizedComponent } from 'utils/memoizeComponent';

import './index.css';

const MassPaymentPopup = memoizedComponent(() => (
  <Frame
    className='mass-payment__frame'
    dataAttribute='loyalty__frame'
    url={`${window.location.origin}/client-area/mass-payments?iframe=true`}
  />
));

const config: ModalAction = {
  wrapperClassName: 'mass-payment-popup-wrapper',
  hideCloseIcon: false,
  closeOnClickOutside: true,
  title: (translate) => translate('mobile:wallet:mass-payments'),
};

export default () => ({
  component: <MassPaymentPopup />,
  ...config,
});
